const doc = [({"en":({"js":({"admin":({"surveys":({"table":({"view_survey":"View survey", "replies":"Replies"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;